export default __webpack_public_path__ + "static/media/2632.65569e86.png";